import { render, staticRenderFns } from "./CreatePosition.vue?vue&type=template&id=4161da21&scoped=true&"
import script from "./CreatePosition.vue?vue&type=script&lang=js&"
export * from "./CreatePosition.vue?vue&type=script&lang=js&"
import style0 from "./CreatePosition.vue?vue&type=style&index=0&id=4161da21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161da21",
  null
  
)

export default component.exports